<div class="back-to-top" [class.show-back-to-top]="showBackToTop" (click)="onClick()">
	<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.5 47.5">
        <defs><style>.cls-1{fill:#79b600;}.cls-2{fill:#fff;}</style></defs>
        <title>{{'back_to_top' | translate}}</title>
        <rect class="cls-1" width="47.5" height="47.5"/><path class="cls-2" d="M13.53,31.77,24,21.29,34.54,31.77l3.23-3.23L24,14.81,10.3,28.54Z" transform="translate(0 -0.5)"/>
    </svg>
</div>